export const registrationType = {
   Combination:      "Combination Week",
   CombinationGroup: "Combination Group",
   Day:              "Day Camp Week",
   Retreat:          "Retreat",
   RetreatGroup:     "Retreat Group",
   Special:          "Special"
}